export default __webpack_public_path__ + "static/media/touchTwo.31796c30.svg";